import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useTextFieldClasses = makeStyles()((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
}));

export const useAutocompleteClasses = makeStyles()({
  popupIndicatorOpen: {
    transform: 'none',
  },
});
